module.exports = __webpack_public_path__ + "static/media/tessa-online.37f1bcad.svg";